import { Box, Dialog, Divider, IconButton, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { StatusBox } from "./StatusBox";
import PetsIcon from '@mui/icons-material/Pets';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import moment from "moment";

export const DetailedService = ({ open, onClose, service }) => {


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <Box position="relative" width="100%" gap={2}>
                <IconButton onClick={onClose}
                    style={{
                        position: 'absolute',
                        right: '0px',
                        top: '0px',
                        width: '24px',
                        height: '24px',
                    }}>
                    <CloseIcon />
                </IconButton>

                <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" gap={2}>
                    <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px">
                        <Typography variant="h6" fontWeight="bold"> Detalhes do Atendimento</Typography>
                    </Box>

                    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" padding="10px" gap={1}>
                        <Box display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
                            <Typography variant="body1" color="text.secondary" >Identificação: </Typography>
                            <Typography variant="body1" fontWeight="bold" >{service?.id}</Typography>
                        </Box>
                        <StatusBox status={service?.status} customStatus={service?.custom_status} />
                    </Box>
                </Box>
                <Divider />
            </Box>

            <Box width="100%" display="flex" flexDirection="column" justifyContent="flex-start" gap={2}>
                <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px" gap={1}>
                    <PetsIcon color="primary" />
                    <Typography variant="h6"> Informações do Pet</Typography>
                </Box>

                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="50%">
                        <Typography variant="body1" color="text.secondary" >Nome</Typography>
                        <Typography variant="body1" fontWeight="bold" >{service?.pet?.name}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="50%">
                        <Typography variant="body1" color="text.secondary" >Raça</Typography>
                        <Typography variant="body1" fontWeight="bold" >{service?.pet?.breed}</Typography>
                    </Box>
                </Box>
                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="100%">
                        <Typography variant="body1" color="text.secondary" >Idade</Typography>
                        <Typography variant="body1" fontWeight="bold" >{service?.pet?.age} anos</Typography>
                    </Box>
                </Box>
                <Divider />

                <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px" gap={1}>
                    <PersonOutlineOutlinedIcon color="primary" />
                    <Typography variant="h6"> Informações do Dono</Typography>
                </Box>

                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="50%">
                        <Typography variant="body1" color="text.secondary" >Nome</Typography>
                        <Typography variant="body1" fontWeight="bold" >{service?.pet?.owner?.name}</Typography>
                    </Box>
                </Box>

                <Divider />

                <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px" gap={1}>
                    <ContentCutOutlinedIcon color="primary" />
                    <Typography variant="h6">Serviço</Typography>
                </Box>

                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="50%">
                        <Typography variant="body1" fontWeight="bold" >{service?.company_service?.name} - R$ {service?.company_service?.cost}</Typography>
                    </Box>
                </Box>

                <Divider />

                <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px" gap={1}>
                    <CalendarTodayOutlinedIcon color="primary" />
                    <Typography variant="h6">Datas</Typography>
                </Box>

                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box width="50%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                            <Box display="flex" gap={1} alignItems="center" width="100%">
                                <Typography variant="body1" color="text.secondary" ><AccessTimeOutlinedIcon sx={{ fontSize: '16px' }} /> </Typography>
                                <Typography variant="body1" color="text.secondary" flexWrap="nowrap">Data de Criação</Typography>
                            </Box>
                            <Typography variant="body1" fontWeight="bold" >{service?.created_at ? moment(service?.created_at).format("DD/MM/YYYY HH:mm") : '-'}</Typography>
                        </Box>
                    </Box>
                    <Box width="50%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                            <Box display="flex" gap={1} alignItems="center" width="100%">
                                <Typography variant="body1" color="text.secondary" ><AccessTimeOutlinedIcon sx={{ fontSize: '16px' }} /> </Typography>
                                <Typography variant="body1" color="text.secondary" flexWrap="nowrap">Data de Início</Typography>
                            </Box>
                            <Typography variant="body1" fontWeight="bold" >{service?.started_at ? moment(service?.started_at).format("DD/MM/YYYY HH:mm") : '-'}</Typography>
                        </Box>
                    </Box>
                    <Box width="50%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                            <Box display="flex" gap={1} alignItems="center" width="100%">
                                <Typography variant="body1" color="text.secondary" ><AccessTimeOutlinedIcon sx={{ fontSize: '16px' }} /> </Typography>
                                <Typography variant="body1" color="text.secondary" flexWrap="nowrap">Última Atualização</Typography>
                            </Box>
                            <Typography variant="body1" fontWeight="bold" >{service?.updated_at ? moment(service?.updated_at).format("DD/MM/YYYY HH:mm") : '-'}</Typography>
                        </Box>
                    </Box>
                    <Box width="50%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                            <Box display="flex" gap={1} alignItems="center" width="100%">
                                <Typography variant="body1" color="text.secondary" ><AccessTimeOutlinedIcon sx={{ fontSize: '16px' }} /> </Typography>
                                <Typography variant="body1" color="text.secondary" flexWrap="nowrap">Data de finalização</Typography>
                            </Box>
                            <Typography variant="body1" fontWeight="bold" >{service?.finished_at ? moment(service?.finished_at).format("DD/MM/YYYY HH:mm") : '-'}</Typography>
                        </Box>
                    </Box>
                </Box>


                <Divider />

                <Box width="100%" display="flex" justifyContent="flex-start" alignItems="center" padding="10px" gap={1}>
                    <DescriptionOutlinedIcon color="primary" />
                    <Typography variant="h6">Observações</Typography>
                </Box>

                <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" gap={3} padding="10px">
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} width="100%">
                        <Typography variant="body1" color="text.secondary" >{service?.observations || 'Ainda não há observações'}</Typography>
                    </Box>
                </Box>
            </Box>




        </Dialog>
    )
}